import {valueOrDefault} from "../utils/Util.js"
import {Editor} from "./Editor.js"
import {Temp} from "../utils/Temp.js"

export class SimpleEditor extends Editor {
	constructor(parent, fieldPath, obj, member, widgetOptions) {
		super(parent, fieldPath, obj, member);
		this.options = widgetOptions;
	}

	get readOnly() {
		return valueOrDefault(this.options.readOnly, super.readOnly);
	}

	option(name, defaultValue) {
		if (this.options == null) return defaultValue;
		const val = this.options[name];
		return val == null ? defaultValue : val;
	}

	rebuild() {
		this.root = Temp.tag('div', this.options);
	}

	displayError(problem) {
		super.displayError(problem);
		if (this.widget != null) this.widget.addClass("error");
		if (this.root != null) {
			this.errorWidget = Temp.tag('div', {clazz: 'perr'});
			this.errorWidget.text(problem.message);
			const maxWidth = Math.max(this.root.width(), 160);
			this.errorWidget.css('max-width', maxWidth + "px");
			this.root.after(this.errorWidget);
		}
	}

	clearError() {
		super.clearError();
		if (this.widget != null) this.widget.removeClass("error");
		if (this.errorWidget != null) this.errorWidget.detach();
	}

	focus() {
		if (this.widget != null) this.widget.focus();	// focus if this editor has a widget
	}


	enableSelf(enable) {
		super.enableSelf(enable);
		this.enableWidget(enable);
		this.options.readOnly = !enable;
	}

	enableWidget(enable) {
		if (enable) {
			if (this.widget != null) this.widget.removeAttr('disabled');
		} else {
			if (this.widget != null) this.widget.attr('disabled', 'disabled');
		}
	}

	updateScreen() {
		if (this.widget != null) this.widget.val(this.fromData(this.data));
	}

	updateData() {
		if (this.widget != null) this.data = this.toData(this.widget.val());
	}
}
